
const mutations = {
  setListBusinessAccount: (state, payload) => {
    state.listBusinessAccount = payload
  },
  setEmployerInfoDetail: (state, payload) => {
    state.employerDetail = payload
  },
  setListConnectingCommentEmployer: (state, payload) => {
    state.listConnectionCommentEmployer = payload
  },
  setListEducationTrainingEmployer: (state, payload) => {
    state.listEducationTrainingEmployer = payload
  },
  setListHistoryEmployer: (state, payload) => {
    state.listHistoryEmployer = payload
  },
  setTotalHistoryEmployer: (state, payload) => {
    state.totalHistoryEmployer = payload
  },
  setListHistoryEmployerAdded: (state, payload) => {
    state.listHistoryEmployerAdded = payload
  },
  setTotalHistoryEmployerAdded: (state, payload) => {
    state.totalHistoryEmployerAdded = payload
  },
  setListNoticeBoardEmployer: (state, payload) => {
    state.listNoticeBoardEmployer = payload
  },
  setListProudOfEmployer: (state, payload) => {
    state.listProudOfEmployer = payload
  },
  setListWorkingPortfolioEmployer: (state, payload) => {
    state.listWorkingPortfolioEmployer = payload
  },
  setListEmploymentHistoryEmployer: (state, payload) => {
    state.listEmploymentHistoryEmployer = payload
  },
  setTalentDetail: (state, payload) => {
    state.talentDetail = payload
  },
  setListConnectingComment: (state, payload) => {
    state.listConnectionComment = payload
  },
  setListEducationTraining: (state, payload) => {
    state.listEducationTraining = payload
  },
  setListWorkingHistory: (state, payload) => {
    state.listWorkingHistory = payload
  },
  setInvoiceUrl: (state, payload) => {
    state.listWorkingHistory = payload
  },
  setTotalWorkingHistory: (state, payload) => {
    state.totalWorkingHistory = payload
  },
  setListNoticeBoard: (state, payload) => {
    state.listNoticeBoard = payload
  },
  setListProudOf: (state, payload) => {
    state.listProudOf = payload
  },
  setListWorkingPortfolio: (state, payload) => {
    state.listWorkingPortfolio = payload
  },
  setListHistoryTalentAdded: (state, payload) => {
    state.listHistoryTalentAdded = payload
  },
  setTotalHistoryTalentAdded: (state, payload) => {
    state.totalHistoryTalentAdded = payload
  },
  setAllowBackPage: (state, payload) => {
    state.allowBackPage[payload.section] = payload.status
  },
  setListJobsToMakeOffer: (state, payload) => {
    state.listJobsToMakeOffer = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js